/**
 * Text snapshot helpers for track-changes diffing (logging removed).
 */

export interface TextSnapshot {
  len: number;
  trimmedLen: number;
  leadingWhitespaceChars: number;
  trailingWhitespaceChars: number;
  doubleSpaceCount: number;
  preview: string;
  tail: string;
  normalized: string;
  normalizedLen: number;
}

export function textSnapshot(text: string, maxPreview = 200): TextSnapshot {
  const preview = text.slice(0, maxPreview);
  const tail = text.slice(Math.max(0, text.length - 80));
  const normalized = text.replace(/\s+/g, ' ').trim();
  return {
    len: text.length,
    trimmedLen: text.trim().length,
    leadingWhitespaceChars: text.length - text.trimStart().length,
    trailingWhitespaceChars: text.length - text.trimEnd().length,
    doubleSpaceCount: (text.match(/  +/g) || []).length,
    preview,
    tail,
    normalized,
    normalizedLen: normalized.length,
  };
}

/** @deprecated Verbose logging removed; kept as no-ops for call sites. */
export function logSuggestEdit(_stage: string, _detail: Record<string, unknown>): void {}

/** @deprecated Verbose logging removed; kept as no-ops for call sites. */
export function logSuggestEditWarn(_stage: string, _detail: Record<string, unknown>): void {}

/** @deprecated Verbose logging removed; kept as no-ops for call sites. */
export function logSuggestEditError(_stage: string, _detail: Record<string, unknown>): void {}

/** @deprecated Verbose logging removed; kept as no-ops for call sites. */
export function logTextBaselineComparison(
  _labelA: string,
  _textA: string,
  _labelB: string,
  _textB: string,
): void {}

/** @deprecated Verbose logging removed; kept as no-ops for call sites. */
export function logWordList(_label: string, _words: string[], _max = 40): void {}

/** @deprecated Verbose logging removed; kept as no-ops for call sites. */
export function logDiffOperations(
  _originalText: string,
  _ops: Array<{ type: string; text: string; startPos: number; endPos: number }>,
): void {}

